<template>
  <v-list-item two-line>
    <v-list-item-avatar>
      <img src="https://cdn2.iconfinder.com/data/icons/hacker-solid/100/hacker_hacker_human_-512.png">
    </v-list-item-avatar>

    <v-list-item-content>
      <v-list-item-title>{{user.username}}</v-list-item-title>
      <v-list-item-subtitle>{{ $t("sidebar.loggedin") }}</v-list-item-subtitle>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name : 'user',

  computed: {
    ...mapGetters({user: 'auth/user'}),
  }
};
</script>